import OneSignal from 'react-onesignal';

export const initOneSignal = async () => {
    try {
        const appId = import.meta.env.VITE_ONESIGNAL_APP_ID;
        if (!appId || appId === 'YOUR_ONESIGNAL_APP_ID_HERE') {
            console.warn("OneSignal App ID eksik. Lütfen .env dosyanıza VITE_ONESIGNAL_APP_ID ekleyin.");
            return;
        }

        // OneSignal web push yalnızca panelde yapılandırılmış domainde çalışır.
        // Diğer origin'lerde (localhost, ugra.io kökü, Vercel preview) SDK
        // "Can only be used on: https://app.ugra.io" fırlatır — bu yüzden atlıyoruz.
        if (window.location.hostname !== 'app.ugra.io') {
            console.info('OneSignal atlandı (desteklenmeyen domain):', window.location.hostname);
            return;
        }

        await OneSignal.init({
            appId: appId,
            allowLocalhostAsSecureOrigin: true, // Gecici testler icin
            notifyButton: {
                enable: false, // Ozel UI kullaniyoruz
            },
        });
        
        console.log("OneSignal başarıyla başlatıldı.");
    } catch (error) {
        console.error("OneSignal başlatılırken hata:", error);
    }
};

/**
 * Müşteri portaldan "Bildirimleri Aç" dediğinde tetiklenecek fonksiyon.
 * Müşterinin external kimliği (global_customer_id) ile OneSignal hesabını bağlar.
 */
export const requestNotificationPermission = async (customerId) => {
    try {
        if (!import.meta.env.VITE_ONESIGNAL_APP_ID || import.meta.env.VITE_ONESIGNAL_APP_ID === 'YOUR_ONESIGNAL_APP_ID_HERE') {
            return { success: false, error: "OneSignal VITE_ONESIGNAL_APP_ID konfigürasyonu eksik." };
        }

        // Tarayıcı destekliyor mu (iOS'da Ana Ekrana Eklenmiş PWA mı kontrolü dahi bir parçasıdır)
        if (!OneSignal.Notifications.isPushSupported()) {
            return { 
                success: false, 
                error: 'not_supported',
                message: 'Cihazınız anlık bildirimleri desteklemiyor. iOS cihazlarda bildirim alabilmek için "Ana Ekrana Ekle" seçeneğiyle uygulamayı ana ekrana yüklemelisiniz.' 
            };
        }

        // Push iznini yerel olarak iste (Kullanıcının karşısına İzin Ver/Engelle kutusu çıkar)
        await OneSignal.Notifications.requestPermission();

        const hasPermission = OneSignal.Notifications.permission === true || OneSignal.Notifications.permission === 'granted';

        if (hasPermission) {
            // İzin verildi, bu tarayıcıyı müşteri kimliği ile etiketliyoruz!
            if (customerId) {
                // Not: OneSignal v16 API'sinde kimlik bağlamak:
                await OneSignal.login(customerId);
            }
            return { success: true };
        } else {
            return { success: false, error: 'Bildirim izni reddedildi.' };
        }
    } catch (error) {
        console.error("OneSignal Push entegrasyon hatası:", error);
        return { success: false, error: error.message };
    }
};

/**
 * Kullanıcı oturumu kapattığında OneSignal ile bağlantıyı keser
 */
export const logoutFromOneSignal = async () => {
    try {
         await OneSignal.logout();
    } catch (error) {
         console.warn("OneSignal (logout) hatası:", error);
    }
}
